var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFiletype = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 42,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M26.788 1.457v8.004h7.753v31.082H1.459V1.457h25.329Z",
  stroke: "url(#filetype_svg__a)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m26.806 1.488 7.735 7.973",
  stroke: "url(#filetype_svg__b)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.945 22.998c.812 0 1.47-.655 1.47-1.463 0-.807-.658-1.462-1.47-1.462-.812 0-1.47.655-1.47 1.462 0 .808.658 1.463 1.47 1.463Z",
  stroke: "url(#filetype_svg__c)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.827 32.746H14.97L20.4 22.528l5.428 10.218Z",
  stroke: "url(#filetype_svg__d)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m10.837 32.746 3.882-7.307 2.074 3.901",
  stroke: "url(#filetype_svg__e)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M25.827 17.715H10.176v15.028h15.65V17.715Z",
  stroke: "url(#filetype_svg__f)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "filetype_svg__a",
  x1: 1.63,
  y1: 40.375,
  x2: 35,
  y2: 40.375,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "filetype_svg__b",
  x1: 1.63,
  y1: 9.75,
  x2: 33.741,
  y2: 9.75,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "filetype_svg__c",
  x1: 1.63,
  y1: 22.875,
  x2: 34.371,
  y2: 22.875,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "filetype_svg__d",
  x1: 1.63,
  y1: 32.875,
  x2: 34.37,
  y2: 32.875,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "filetype_svg__e",
  x1: 2.259,
  y1: 32.875,
  x2: 34.371,
  y2: 32.875,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "filetype_svg__f",
  x1: 1.63,
  y1: 32.875,
  x2: 34.37,
  y2: 32.875,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})))));
export { SvgFiletype as ReactComponent };
export default __webpack_public_path__ + "/assets/6f48227cb3fd15baec3d3d766bd0d8d9.svg";